import React from 'react';
import Select from 'react-select';
import classnames from 'classnames';

import styles from './select-component.styles.scss';

export const SelectComponent = (_props) => {
  const { className, ...props } = _props;
  const classNames = classnames(className, styles.Select);

  return (
    <Select
      searchable={false}
      clearable={false}
      {...props}
      className={classNames}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/select/select.component.jsx